export default "__VITE_ASSET__BU_VlMa1__"